import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal } from 'antd';
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  setTab: (tab: string) => void;
  memberCode: string;
}

const CompleteTransfer2Modal: FC<IProps> = ({
  visible,
  setVisible,
  setTab,
  memberCode,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { chosenClass } = useSelector((state: RootState) => state.class);
  
  return (
    <Modal
      title={t('class.class.title9')}
      visible={visible}
      onCancel={() => {
        setVisible(false);
        setTab('register');
      }}
      footer={[
        <div className='comm-btn__area justify-content-center'>	
          <AntButton
            key="primary"
            className='btn-basic pink'
            onClick={() => {
              setVisible(false);
              history.push(`/student/student?memberCode=${memberCode}&campusCode=${chosenClass?.campusCode}&tabIndex=3`)
            }}
          >
            {t('common.option.yes')}
          </AntButton>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={() => {
              setVisible(false);
              setTab('register');
            }}
          >
            {t('common.option.no')}
          </AntButton>
        </div>
      ]}
    >
      {t('class.class.text22')}{' '}
      {t('class.class.text23')}
    </Modal>
  );
}

export default CompleteTransfer2Modal;
